import { createContext, useContext } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import type { ProductDayTripPlanFormModel } from "../../../model/type";

type QueryData = ProductDayTripPlanFormModel["QueryData"];
type ViewModel = ProductDayTripPlanFormModel["ViewModel"];

export type ProductDayTripPlanFormModelContextType = {
	viewModel: ViewModel;
	initInputModel: ProductDayTripPlanFormModel["InputModel"];
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;

	testEmailSender: {
		sendTestMailAtReservationCreate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationUpdate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationCancel: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore07Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore00Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckOutAfter01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
	};
};

export const ProductDayTripPlanFormModelContext = createContext<ProductDayTripPlanFormModelContextType | null>(null);

export const useProductDayTripPlanFormModelContext = () => {
	const context = useContext(ProductDayTripPlanFormModelContext);

	if (!context) {
		throw new Error(
			"useProductDayTripPlanFormModelContext must be used within a ProductDayTripPlanFormModelContext.Provider",
		);
	}

	return context;
};
